import { useSelector } from "react-redux";
import { toUrlExcursionVendor } from "../../../helper/vendorMask";
import { ApiCall, GetApiCall } from "../../../helper/axios";
import { getActiveCode, getActiveRate } from "../../../helper/currencyState";
import { getUserToken, paymentCancelCommonFn, paymentCaptureCommonFn } from "../../../helper/commonFunction";
import { useEffect, useRef, useState } from "react";
import { useDoConfirm } from "./useDoConfirm";
import { useNavigate } from "react-router-dom";
// import { loadSimmplifyScripts } from "../../../helper/simplify-script"; // Temporarily disabled

export const useDoPayment = (totalPrice, onlineServiceFeeAmount = 0) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  let userToken = getUserToken();
  const { agentActiveCurrency } = useSelector((state) => state.userData);
  const { save, loading: confirming } = useDoConfirm();
  const payloadRef = useRef(null);


  const getBalance = async () => {
    try {
      let balance;
      setLoading(true);
      setError(null);
      const walletBalanceData = await GetApiCall(
        "GET",
        `wp-json/dahr/v1/user-wallet-balance?userToken=${userToken}&activeUserCurrency=${agentActiveCurrency}`,
        {},
        "wordpress"
      );
      if (walletBalanceData?.status === 200) {
        balance = walletBalanceData?.data?.wallet_balance;
      }
      return balance;
    } catch (error) {
      setError(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const generateNonceForTranscationFn = async (transcationType = 'wallet', type = 'debit') => {
    let nonceToken = '';
    const nonceData = await GetApiCall('GET', `wp-json/dahr/v1/generate-nonce?userToken=${userToken}&transaction_type=${type}&type=${transcationType}`, {}, 'wordpress');
    if (nonceData?.status === 200) {
      nonceToken = nonceData?.data?.nonce;
    }
    return nonceToken;
  }

  const debit = async (amount, productName, payment_mode = "wallet") => {
    let totalAmount = amount;
    let nonceToken = await generateNonceForTranscationFn('wallet', 'debit');
    const deductBalanceFromWallet = await ApiCall(
      "POST",
      `wp-json/dahr/v1/wallet-transaction`,
      {
        userToken: userToken,
        activeUserCurrency: agentActiveCurrency,
        display_currency: getActiveCode(),
        conversion_rate: getActiveRate(),
        transaction_type: "debit",
        payment_mode,
        amount: totalAmount,
        nonce: nonceToken,
        transaction_comment: `Debited Towards: Excursion Booking of ${productName}`,
      },
      {},
      "wordpress"
    );
    return deductBalanceFromWallet;
  };

  const credit = async (amount, productName, payment_mode = "wallet", customError = false, walletTranscationId = '') => {
    let totalAmount = amount;
    let nonceToken = await generateNonceForTranscationFn(payment_mode, 'credit');
    let payload = {
      userToken: userToken,
      activeUserCurrency: agentActiveCurrency,
      display_currency: getActiveCode(),
      conversion_rate: getActiveRate(),
      transaction_type: "credit",
      payment_mode,
      amount: totalAmount,
      nonce: nonceToken,
      transaction_comment: `Credited Towards: Failed Excursion Ticket Of ${productName}`,
    }
    if (customError) {
      payload.status = 'pending';
    }
    if (walletTranscationId) {
      payload.transactionId = walletTranscationId;
    }
    const deductBalanceFromWallet = await ApiCall(
      "POST",
      `wp-json/dahr/v1/wallet-transaction`,
      payload,
      {},
      "wordpress"
    );
    return deductBalanceFromWallet;
  };

  const doTransaction = async (
    amount,
    {
      time,
      endTime,
      variationId,
      eventId,
      variationTitle,
      productName,
      date,
      paymentMethod,
      transfer,
      eId,
      price,
      persons,
      isEmaar,
      isEmaarV1,
      tickets,
      isHelidubai,
      isDubaiPark,
      isDubaiProductId,
      TourProductId,
      TourScheduleId,
      TourId,
      duration,
      bookingReference,
      jwt,
      IsEventBased,
      openDay,
      vendorBased,
      emaarV1Tickets,
      IsEticketRequired,
      slotData,
      taxData,
      raynaData,
      parmarData,
      commonId
    }
  ) => {
    let errorMessage;
    let actualError;
    let customError = false;
    try {
      const walletBalance = await getBalance();
      setLoading(true);
      setError(null);
      if (!isNaN(amount) && parseFloat(walletBalance) >= parseFloat(amount)) {
        const deductBalanceFromWallet = await debit(amount, productName);
        if (
          deductBalanceFromWallet?.status === 200 &&
          deductBalanceFromWallet?.data?.success &&
          deductBalanceFromWallet?.data?.transaction_id
        ) {
          const confirmResponse = await save({
            time,
            endTime,
            variationId,
            eventId,
            variationTitle,
            date,
            paymentMethod,
            transfer,
            eId,
            price,
            persons,
            isEmaar,
            tickets,
            isHelidubai,
            isDubaiPark,
            isDubaiProductId,
            TourProductId,
            TourScheduleId,
            TourId,
            duration,
            jwt,
            bookingReference,
            IsEventBased,
            transactionId: deductBalanceFromWallet?.data?.transaction_id,
            openDay,
            vendorBased,
            emaarV1Tickets,
            IsEticketRequired,
            isEmaarV1,
            slotData,
            taxData,
            raynaData,
            parmarData,
            commonId
          });
          if (confirmResponse?.data?.booking_id) {
            window.scrollTo(0, 0);
            navigate(
              `/excursion/checkout?bId=${confirmResponse?.data?.booking_id}${
                confirmResponse?.data?.vendor ? `&vendor=${toUrlExcursionVendor(confirmResponse.data.vendor)}` : ""
              }`,
              { replace: true }
            );
            return confirmResponse?.data?.booking_id;
          } else {
            actualError = confirmResponse;
            errorMessage = confirmResponse?.message ||
              confirmResponse?.data?.message ||
              confirmResponse?.data?.data?.error_message ||
              "If your payment has been debited, but the ticket is not yet confirmed. Please do not attempt to book again. Contact the admin for assistance with your ticket."
            if (errorMessage === 'If your payment has been debited, but the ticket is not yet confirmed. Please do not attempt to book again. Contact the admin for assistance with your ticket.') {
              customError = true;
            }
            throw new Error(
              errorMessage
            );
          }
        }
        return null;
      } else {
        setError(`Insufficient Balance. Your Total Balance is: ${walletBalance} <br/>
        <a target="_blank" href="${process.env.wordpressApiEndPoint}dashboard/?tab=new-balance-request" class="hw-link--line">Add your Balance</a>`);
      }
    } catch (error) {
      await ApiCall("POST", '/generate-error', { error, errorMessage, actualError });
      if (customError) {
        const elementForBtn = document.querySelectorAll('.excursion-book-btn-hide');
        if (elementForBtn?.length) {
          elementForBtn.forEach(el => {
            el.style.setProperty('display', 'none', 'important');
          });
        }
      }
      await credit(amount, productName, 'wallet', customError);
      setError(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const confirmAfterOnlinePayment = async (
    amount,
    {
      time,
      endTime,
      variationId,
      eventId,
      variationTitle,
      productName,
      date,
      paymentMethod,
      transfer,
      eId,
      price,
      persons,
      isEmaar,
      isEmaarV1,
      tickets,
      isHelidubai,
      bookingReference,
      isDubaiPark,
      isDubaiProductId,
      TourProductId,
      TourScheduleId,
      TourId,
      duration,
      jwt,
      IsEventBased,
      openDay,
      vendorBased,
      emaarV1Tickets,
      IsEticketRequired,
      slotData,
      taxData,
      raynaData,
      parmarData,
      commonId
    }, payment = null
  ) => {
    let errorMessage;
    let actualError;
    let customError = false;
    if (payment?.status === "requires_capture") {
      let walletTranscationId;
      try {
        setLoading(true);
        setError(null);
        const deductBalanceFromWallet = await debit(
          amount + onlineServiceFeeAmount,
          productName,
          "online"
        );
        if (
          deductBalanceFromWallet?.status === 200 &&
          deductBalanceFromWallet?.data?.success &&
          deductBalanceFromWallet?.data?.transaction_id
        ) {
          walletTranscationId = deductBalanceFromWallet?.data?.transaction_id;
          let onlinePayment = {
            amount: price,
            onlineServiceFeeAmount
          }
          const confirmResponse = await save({
            time,
            endTime,
            variationId,
            eventId,
            variationTitle,
            date,
            paymentMethod,
            transfer,
            eId,
            price: price + onlineServiceFeeAmount,
            persons,
            isEmaar,
            isEmaarV1,
            tickets,
            isHelidubai,
            isDubaiPark,
            isDubaiProductId,
            TourProductId,
            TourScheduleId,
            TourId,
            duration,
            jwt,
            IsEventBased,
            transactionId: payment?.id,
            onlinePayment,
            openDay,
            vendorBased,
            emaarV1Tickets,
            IsEticketRequired,
            slotData,
            bookingReference,
            taxData,
            raynaData,
            parmarData,
            commonId
          });
          if (confirmResponse?.data?.booking_id) {
            await paymentCaptureCommonFn(payment?.id, userToken);
            window.scrollTo(0, 0);
            navigate(
              `/excursion/checkout?bId=${confirmResponse?.data?.booking_id}${
                confirmResponse?.data?.vendor ? `&vendor=${toUrlExcursionVendor(confirmResponse.data.vendor)}` : ""
              }`,
              { replace: true }
            );
            return confirmResponse?.data?.booking_id;
          } else {
            actualError = confirmResponse;
            errorMessage = confirmResponse?.message ||
              confirmResponse?.data?.message ||
              confirmResponse?.data?.data?.error_message ||
              "If your payment has been debited, but the ticket is not yet confirmed. Please do not attempt to book again. Contact the admin for assistance with your ticket."
            if (errorMessage === 'If your payment has been debited, but the ticket is not yet confirmed. Please do not attempt to book again. Contact the admin for assistance with your ticket.') {
              customError = true;
            }
            throw new Error(errorMessage);
          }
        }
      } catch (error) {
        await ApiCall("POST", '/generate-error', { error, errorMessage, actualError });
        if (customError) {
          const elementForBtn = document.querySelectorAll('.excursion-book-btn-hide');
          if (elementForBtn?.length) {
            elementForBtn.forEach(el => {
              el.style.setProperty('display', 'none', 'important');
            });
          }
        }
        if (customError) {
          await paymentCaptureCommonFn(payment?.id, userToken);
        } else {
          await paymentCancelCommonFn(payment?.id, userToken);
        }
        // await credit(amount, productName, 'online', customError,walletTranscationId);
        setError(error?.message);
        return null;
      } finally {
        setLoading(false);
      }
    }
  };

  // Online payment function temporarily disabled due to Simplify integration issues
  const doOnlinePayment = (
    amount,
    {
      time,
      endTime,
      variationId,
      eventId,
      variationTitle,
      productName,
      date,
      paymentMethod,
      transfer,
      eId,
      price,
      persons,
      isEmaar,
      tickets,
      isHelidubai,
      isDubaiPark,
      isDubaiProductId,
      TourProductId,
      TourScheduleId,
      TourId,
      duration,
    }
  ) => {
    payloadRef.current = {
      time,
      endTime,
      variationId,
      eventId,
      variationTitle,
      productName,
      date,
      paymentMethod,
      transfer,
      eId,
      price: price + onlineServiceFeeAmount,
      persons,
      isEmaar,
      tickets,
      isHelidubai,
      isDubaiPark,
      isDubaiProductId,
      TourProductId,
      TourScheduleId,
      TourId,
      duration,
    };
    setLoading(true);
    addListner();
    setTimeout(() => {
      document.querySelector(".online_book_now_btn").click();
    }, 500);
  };

  return {
    getBalance,
    doTransaction,
    loading: loading || confirming,
    error,
    // doOnlinePayment, // Temporarily disabled due to Simplify integration issues
    confirmAfterOnlinePayment,
    save,
    setLoading,
    setError
  };
  // return { doTransaction, confirmAfterOnlinePayment, loading, error };
};
